"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputSystem = void 0;
// type: 'controller' | 'mouse' | 'keyboard' | 'touch'
class InputSystem {
    //   protected mappedActionToOrderedInputCombos : {[action: string]: Array<string>}
    //  protected mappedActionToUnorderedInputCombos : {[action: string]: Array<string>}
    // protected inputToActionCombos : {[inputId: string]: Array<actionCombo> }
    constructor(mappedActionToInputIds) {
        this._onActionListeners = {};
        this._onMappedActionAddedListeners = [];
        this._onMappedActionRemovedListeners = [];
        this.actionState = {};
        this.actionNames = [];
        this.mappedInputIdToActions = {};
        this.mappedActionToInputIds = {};
        mappedActionToInputIds && this.applyActionToInputMap(mappedActionToInputIds);
    }
    applyActionToInputMap(mappedActionToInputIds) {
        if (!this.validateActionToInputMap(mappedActionToInputIds))
            throw new Error(`Invalid.`);
        for (let action in mappedActionToInputIds) {
            this.addActionState(action, false);
            mappedActionToInputIds[action].forEach(input => {
                this.mapInputIdToAction(input, action);
            });
        }
    }
    getMappedActionInputs() {
        return Object.assign({}, this.mappedActionToInputIds);
    }
    validateActionToInputMap(mappedActionToInputIds) {
        //todo:... make sure nothing gets removed when it shouldnt.
        return true;
    }
    update() {
        var _a, _b, _c;
        const prevState = Object.assign({}, this.actionState);
        this.updateState();
        let changed = null;
        for (let i = 0; i < this.actionNames.length; i++) {
            const curAction = this.actionNames[i];
            const previous = prevState[curAction];
            const current = this.actionState[curAction];
            if ((typeof current !== 'object' && previous !== current) ||
                // @ts-ignore
                (current.power !== (previous === null || previous === void 0 ? void 0 : previous.power) || ((_a = current.angles) === null || _a === void 0 ? void 0 : _a.default.degrees) !== ((_b = previous.angles) === null || _b === void 0 ? void 0 : _b.default.degrees))) {
                changed = changed || {};
                const changeObj = { previous, current };
                changed[curAction] = changeObj;
                (_c = this._onActionListeners[curAction]) === null || _c === void 0 ? void 0 : _c.forEach(l => l(changeObj));
            }
        }
        // @ts-ignore
        return { state: this.actionState, changed };
    }
    getUnmappedActions() {
        return this.actionNames.filter(n => {
            return !(n in this.mappedActionToInputIds);
        });
    }
    handleActionChange(actionName, value) {
        if (!(actionName in this.actionState))
            throw new Error(`Invalid action changed ${actionName}`);
    }
    addActionState(action, value = false) {
        if (action in this.actionState)
            throw new Error(`Already added action ${action}`);
        this.actionState[action] = value;
        this.actionNames = Object.keys(this.actionState);
    }
    removeActionState(action) {
        if (!(action in this.actionState))
            throw new Error(`No action added: ${action}`);
        delete this.actionState[action];
        this.actionNames = Object.keys(this.actionState);
    }
    onActionChange(actionName, cb) {
        if (this._onActionListeners[actionName]) {
            this._onActionListeners[actionName].push(cb);
        }
        else {
            this._onActionListeners[actionName] = [cb];
        }
    }
    offActionChange(actionName, cb) {
        const listeners = this._onActionListeners[actionName];
        if (listeners) {
            const idx = listeners.indexOf(cb);
            idx > -1 && listeners.splice(idx, 1);
            if (!listeners.length) {
                delete this._onActionListeners[actionName];
            }
        }
    }
    onMappedActionAdded(cb) {
        return this._onMappedActionAddedListeners.push(cb);
    }
    offMappedActionAdded(cb) {
        const idx = this._onMappedActionAddedListeners.push(cb);
        idx > -1 && this._onMappedActionAddedListeners.splice(idx, 1);
        return this._onMappedActionAddedListeners.length;
    }
    onMappedActionRemoved(cb) {
        return this._onMappedActionRemovedListeners.push(cb);
    }
    offMappedActionRemoved(cb) {
        const idx = this._onMappedActionRemovedListeners.indexOf(cb);
        idx > -1 && this._onMappedActionRemovedListeners.splice(idx, 1);
        return this._onMappedActionRemovedListeners.length;
    }
    unmapInputFromAction(inputId, action) {
        if (Array.isArray(inputId)) {
            inputId.forEach(i => {
                this.unmapInputFromAction(i, action);
            });
            return;
        }
        const actions = this.mappedInputIdToActions[inputId];
        if (typeof actions === 'undefined') {
            throw new Error(`The inputId ${inputId} was not mapped to any action.`);
        }
        const eventData = { inputId, action, actionNowUnmapped: false };
        const idx1 = actions.indexOf(action);
        if (idx1 < 0) {
            throw new Error(`The inputId ${inputId} was not mapped to action ${action}.`);
        }
        actions.splice(idx1, 1);
        if (!actions.length) {
            delete this.mappedInputIdToActions[inputId];
        }
        const idx = this.mappedActionToInputIds[action].indexOf(inputId);
        if (idx < 0)
            throw new Error(`Index should be greater than -1`);
        this.mappedActionToInputIds[action].splice(idx, 1);
        if (!this.mappedActionToInputIds[action].length) {
            delete this.mappedActionToInputIds[action];
        }
        this._onMappedActionRemovedListeners.forEach(l => l(eventData));
        return eventData;
    }
    mapInputIdToAction(inputId, action) {
        if (Array.isArray(inputId)) {
            inputId.forEach(i => {
                this.mapInputIdToAction(i, action);
            });
            return;
        }
        if (Array.isArray(action)) {
            action.forEach(a => {
                this.mapInputIdToAction(inputId, a);
            });
        }
        this.actionState[action] = false;
        const eventData = { action: action, inputId };
        const cur = this.mappedInputIdToActions[inputId];
        if (cur === null || cur === void 0 ? void 0 : cur.includes(action))
            return;
        if (!this.mappedInputIdToActions[inputId]) {
            this.mappedInputIdToActions[inputId] = [action];
        }
        else {
            this.mappedInputIdToActions[inputId].push(action);
        }
        if (!this.mappedActionToInputIds[action]) {
            this.mappedActionToInputIds[action] = [inputId];
        }
        else {
            this.mappedActionToInputIds[action].push(inputId);
        }
        this._onMappedActionAddedListeners.forEach(l => l(eventData));
        return eventData;
    }
    resolveActions(inputId, filterOutAlreadyTrue = false) {
        return this.mappedInputIdToActions[inputId];
    }
    resolveInputs(action) {
        return this.mappedActionToInputIds[action];
    }
    getDuplicateInputs() {
        const dup = {};
        Object.keys(this.mappedInputIdToActions).forEach(k => {
            if (this.mappedActionToInputIds[k].length > 1) {
                dup[k] = this.mappedActionToInputIds[k];
            }
        });
        return dup;
    }
}
exports.InputSystem = InputSystem;
//# sourceMappingURL=module.js.map